import { Driver } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack } from '@mui/material';
import React from 'react';

import CardWrapper from '../../CardWrapper';
import DriverDetails from './DriverDetails';

interface Props {
  data: Driver[];
}

const DriversCard: React.FC<Props> = ({ data }: Props) => {
  return (
    <CardWrapper title="Drivers">
      <Stack spacing={{ mobile: 2, tablet: 3 }} width={1}>
        {data.map((item, idx) => (
          <DriverDetails
            key={`${item.firstName}-${item.lastName}--${idx}`}
            data={item}
          />
        ))}
      </Stack>
    </CardWrapper>
  );
};

export default DriversCard;
